import { useAuth0 } from '@/auth';
import { Auth0PluginOptions } from '@/auth/types/auth0PluginOptions';
import { VueConstructor } from 'vue';

export default {
  install(Vue: VueConstructor, options: Auth0PluginOptions) {
    Vue.prototype.$auth = useAuth0(options);
  }
};
